import { BLUE_600 } from 'constants/styling/upbrandingTheme'
import React from 'react'
import ReactLoading from 'react-loading'
import Stack from '@mui/material/Stack'
import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface Props {
  /** Text of the loading. */
  loadingText?: string
}

/**
 * @component
 *
 * @example
 * <GenerateLoading
 *   loadingText="Generating results..."
 * />
 */
export const GenerateLoading: React.FC<Props> = ({
  loadingText
}) => {

  const { t } = useTranslation(['ai_studio_editing'])

  return (
    <Stack
      position="absolute"
      top={0}
      left={0}
      width="100%"
      height="100%"
      alignItems="center"
      justifyContent="center"
      sx={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
    >
      <Stack
        position="relative"
        width="100%"
        height="100%"
        alignItems="center"
        justifyContent="center"
      >

        <Stack
          position='absolute'
          width="100vw"
          height="100vh"
          sx={{ backdropFilter: 'blur(4px)' }}
        />

        <Stack
          position='absolute'
          width="100vw"
          height="100vh"
          alignItems="center"
          justifyContent="center"
          sx={{ zIndex: 1300, pointerEvents: 'none' }} // zIndex above modal, pointerEvents so background is not blocked
        >

          <ReactLoading
            type="spin"
            color={BLUE_600}
            width={25}
            height={25}
          />

          <Typography variant='text-md' fontWeight='bold' color="white" mt={2}>
            {loadingText ?? t('generating_results')}
          </Typography>

        </Stack>

      </Stack>
    </Stack>
  )
}
